import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import CategoryCardTop from "../../components/CategoryCardTop/CategoryCardTop";
import TourCardIndividual from "../../components/TourCard/TourCardIndividual";
import Pagination from "../../components/Pagination/Pagination";
import titleImage from '../../assets/images/titleImage.png';
import s from "../TourDetails/TourDetails.module.scss";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import NotFound from "../../components/Loading/NotFound";
import SeoMeta from "../../components/SeoMeta";
import api from "../../api/client";

const ToursByCategory = ({sale = false, tags = "", fromHome = false}) => {
    const {slug} = useParams();

    const apiUrl = process.env.REACT_APP_API_URL;

    const navigate = useNavigate();
    const location = useLocation();
    const uri = location.pathname;
    const queryParams = new URLSearchParams(location.search);

    const [categories, setCategories] = useState([]);
    const [tours, setTours] = useState([]);
    const [loading, setLoading] = useState(false);
    const [slugCategoryName, setSlugCategoryName] = useState("");

    const [page, setPage] = useState(parseInt(queryParams.get("page")) || 1);
    const [selectedCategory, setSelectedCategory] = useState(
        queryParams.get("category") || null
    );
    const [totalPages, setTotalPages] = useState(1);
    const queryKeyword = new URLSearchParams(location.search).get('kw') || '';
    const thirdBreadcrumbName = location.state?.breadcrumbItems?.[2]?.name.replace(/"/g, '');
    // ✅ Load categories
    useEffect(() => {
        axios.get(`${apiUrl}/api/categories`)
            .then(res => setCategories(res.data))
            .catch(err => console.error(err));
    }, []);
    useEffect(() => {
        if (!slug) return;

        axios.get(`${apiUrl}/api/category/${slug}`)
            .then(res => {
                setSlugCategoryName(res.data.name);
            })
            .catch(err => console.error(err));
    }, [slug]);
    // ✅ Sync URL → state
    useEffect(() => {
        const qp = new URLSearchParams(location.search);

        setPage(parseInt(qp.get("page")) || 1);
        setSelectedCategory(qp.get("category") || null);

    }, [location.search]);

    // ✅ Fetch tours (like TourList)
    useEffect(() => {
        setLoading(true);

        const qp = new URLSearchParams(location.search);

        const params = new URLSearchParams();

        const locationQp = qp.get("location");
        const category = qp.get("category");
        const page = qp.get("page") || 1;
        const kw = qp.get("kw");
        const tags = qp.get('tags');

        if (slug) params.set("categorySlug", slug);
        if (locationQp) params.set("location", locationQp);
        if (category) params.set("category", category);
        if (kw) params.set("kw", kw);
        if (sale) params.set("sale", true);
        if (tags) params.set("tags", tags);
        params.set("page", page);

        api.get(`/api/search?${params.toString()}`)
            .then(res => {
                setTours(res.data.data);
                setTotalPages(res.data.last_page);
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false));

    }, [location.search]);

    // ✅ Handle category click
    const handleCategoryClick = (id) => {
        const params = new URLSearchParams(location.search);

        if (id) {
            params.set("category", id);
        } else {
            params.delete("category"); // ✅ important
        }

        params.set("page", 1);

        navigate({search: params.toString()});
    };

    // ✅ Pagination click
    const handlePageChange = (newPage) => {
        const params = new URLSearchParams(location.search);

        params.set("page", newPage);

        navigate({search: params.toString()});
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 0);
    };
    const removeFilter = (key) => {
        const params = new URLSearchParams(location.search);

        params.delete(key);

        // reset page
        params.set("page", 1);

        navigate({search: params.toString()});
    };

    const clearAllFilters = () => {
        navigate("/all-tours");
    };
    const selectedCategoryName = categories.find(
        c => String(c.id) === String(selectedCategory)
    )?.name;

    const selectedTags = queryParams.get("tags")
        ? queryParams.get("tags").split(",").filter(Boolean)
        : [];

    const removeTag = (tagToRemove) => {
        const params = new URLSearchParams(location.search);

        const currentTags = params.get("tags")
            ? params.get("tags").split(",").filter(Boolean)
            : [];

        const updatedTags = currentTags.filter(
            tag => tag !== tagToRemove
        );

        if (updatedTags.length > 0) {
            params.set("tags", updatedTags.join(","));
        } else {
            params.delete("tags");
        }

        params.set("page", 1);

        navigate({search: params.toString()});
    };

    const pageName = slug && slugCategoryName
        ? slugCategoryName
        : sale
            ? "特別オファー"
            : tags !== ""
                ? "Student Tours"
                : "ツアーを選ぶ";
    const breadcrumbItems = [
        {name: "ホーム", link: "/"},
        {name: pageName}
    ];


    if (!loading && tours.length === 0) {
        return (
            <NotFound/>
        )
    }
    return (
        <>
            {!fromHome &&  <SeoMeta
                slug={window.location.pathname}
                fallback={{
                    title: pageName,
                    description: pageName,
                    image: "",
                    url: `${process.env.REACT_APP_URL}${window.location.pathname}`
                }}
            />}
            {/* TITLE */}
            <div className="row mt-3 mb-3">
                <div className="col-12">
                    {!fromHome && <Breadcrumb items={breadcrumbItems}/>}
                    <div className={s.titleWrrapper}>
                        <img className={s.titleImage} src={titleImage}/>
                        <h2 className={s.primaryTitle}>{pageName}</h2>
                        <h3 className={s.secondaryTitle}>{sale ? "Special Offers" : tags !== "" ? "Student Tours" : "Tour Introduction"}</h3>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">

                    {/* CATEGORY */}
                    {!slug && <CategoryCardTop
                        categories={categories}
                        onCategoryClick={handleCategoryClick}
                        activeCategory={selectedCategory}
                    />}
                    <div className="d-flex flex-wrap gap-2 mt-4 mb-3">

                        {queryKeyword && (
                            <div className={s.filterTag}>
                                <span>キーワード： {queryKeyword}</span>

                                <button onClick={() => removeFilter("kw")}>
                                    ✕
                                </button>
                            </div>
                        )}

                        {selectedCategoryName && (
                            <div className={s.filterTag}>
                                <span>カテゴリー： {selectedCategoryName}</span>

                                <button onClick={() => removeFilter("category")}>
                                    ✕
                                </button>
                            </div>
                        )}
                        {selectedTags.map(tag => (
                            <div className={s.filterTag} key={tag}>
                                <span>タグ： {tag}</span>

                                <button onClick={() => removeTag(tag)}>
                                    ✕
                                </button>
                            </div>
                        ))}

                        {queryParams.get("location") && (
                            <div className={s.filterTag}>
                                <span>Location: {thirdBreadcrumbName}</span>

                                <button onClick={() => removeFilter("location")}>
                                    ✕
                                </button>
                            </div>
                        )}

                        {(queryKeyword || selectedCategory || queryParams.get("location") ||
                            selectedTags.length > 0) && (
                            <button
                                className={s.clearAllBtn}
                                onClick={clearAllFilters}
                            >
                                すべてクリア
                            </button>
                        )}

                    </div>
                    {/* TOURS */}
                    <div className="row mt-5">
                        {loading && Array.from({length: 8}).map((_, i) => (
                            <div className="col-6  col-lg-4 col-xl-3  mb-4" key={i}>
                                <TourCardIndividual loading/>
                            </div>
                        ))}

                        {!loading && tours.map((tour) => (
                            <div className="col-6  col-lg-4 col-xl-3 mb-4" key={tour.id}>
                                <TourCardIndividual item={tour}/>
                            </div>
                        ))}
                    </div>

                    {/* PAGINATION (reuse your component) */}
                    <Pagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />

                </div>
            </div>
        </>
    );
};

export default ToursByCategory;